<template>
	<div calss="w-100" style="min-height: 100%;">
		<header class="nav nav-holder fixed-top">
			<div class="flex-row flex-between" :class="{'w-1200': language == 'ZH', 'w-1250': language == 'EN' }">
				<div class="flex-row">
					<img class="d-none d-md-inline-block" src="@/assets/img/index/logo.png" alt="Universal logo"
						style="width: 180px; height:auto;">
				</div>
				<div class="nav_inner mg-lt-30 flex-row">
					<ul id="navs" class="" v-if="navList.length != 0">
						<li class="nav-item dropdown ps-re" v-for="item in navList" :key="item.id">
							<router-link class="nav-link" :to="item.path">{{item.name}}</router-link>
							<ul class="dropdown-menu dropdown-menu-end w-100" v-if="!!item.children && item.children.length != 0">
								<li class="w-100" v-for="child in item.children" :key="child.id">
									<div class="dropdown-item" @click="handleToPath(child)">{{child.name}}</div>
								</li>
							</ul>
						</li>
						<div class="active" id="active"></div>
					</ul>

					<div class="flex-row mg-lt-30 lang">
						<!-- <div class="flex-row">
							<div class="lang-item" :class="{'langActive': language == 'ZH' }" @click="changeLangEvent('ZH')">ZH</div>
							<div class="mg-lr-10">|</div>
							<div class="lang-item" :class="{'langActive': language == 'EN' }" @click="changeLangEvent('EN')">EN</div>
						</div> -->

						<div class="flex-row mg-lt-20 login" v-if="!isLogin">
							<div @click='handleLogin'>{{$t('login.signIn')}}</div>
							<div class="mg-lr-5">|</div>
							<div @click='handleRegister'>{{$t('login.register')}}</div>
						</div>
					</div>

					<div class="flex-row mg-lt-30 hg-100 user" style=" cursor: pointer;" v-if="isLogin">
						<div class="flex-row ps-re hg-100">
							<div class="clr-4fb ft-se-18 ft-bd pd-rt-15">
								{{user.userName}}
							</div>
							<!-- <i class="el-icon-caret-bottom ft-se-24 clr-4fb"></i> -->
							<!-- background: #4baf4f; border: #4baf4f solid 1px; -->
							<div class="of-hd flex-row flex-center" style="width: 40px; height: 40px; border-radius: 50%; ">
								<img src="@/assets/img/connectus/user-6.png" alt="" srcset="" style="width: 70%;" />
							</div>
							<ul class="dropdown-menu-u dropdown-menu-end w-100">
								<li class="w-100 tx-ot-1 mg-tp-10">
									<div class="flex-row">
										<!-- style="width: 40px; height: 40px; border-radius: 50%; background: #d3dce6;" -->
										<div class="of-hd flex-row flex-center mg-rt-15"
											style="width: 40px; height: 40px; border-radius: 50%; ">
											<img src="@/assets/img/connectus/user-8.png" alt="" srcset="" style="width: 70%;" />
										</div>
										<!-- 账号： -->
										<div class="flex-1 tx-jt">
											<div class="ft-bd ft-se-16  tx-ot-1">
												{{user.userName}}
											</div>
											<!-- <div class="clr-4fb ft-se-14 mg-tp-5">
												编辑个人信息 <i class="el-icon-d-arrow-right ft-se-14 clr-4fb mg-lt-5"></i>
											</div> -->
										</div>
									</div>
								</li>
								<li class="w-100 tx-ot-1" v-for="child in userList" :key="child.id">
									<div class="dropdown-item" @click="handlePath(child)">{{child.name}}</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</header>

		<section class="app-main" style="min-height: calc(100vh - 200px);">
			<transition name="router-fade" mode="out-in">
				<keep-alive>
						<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
			</transition>
	
			<transition name="router-fade" mode="out-in">
				<router-view v-if="!$route.meta.keepAlive"></router-view>
			</transition>
			<!-- <transition name="fade-transform" mode="out-in"> -->
				 <!--这里是会被缓存的组件-->
			<!-- 需要缓存数据的页面 -->
			<!-- 	<keep-alive v-if="$route.meta.keepAlive">
					<router-view v-if="$route.meta.keepAlive" :key="key"/>
				</keep-alive> -->
				<!-- 不需要缓存数据的页面 -->
				<!-- <router-view v-if="!$route.meta.keepAlive" :key="key"/> -->
				<!-- <keep-alive v-if="!$router.meta.keepAlive">
					<router-view :key="key"></router-view>
				</keep-alive> -->
				
				<!--这里是不会被缓存的组件-->
			<!-- 	<keep-alive v-if="$route.meta.KeepAlive">
					<router-view :key="key" />
				</keep-alive>
				<router-view :key="key" v-if="!$route.meta.KeepAlive"/> -->
			<!-- </transition> -->
		</section>

		<footer class="footer flex-row flex-center flex-wrap">
			<div class="w-1200 flex-row flex-row-item">
				<div class="tx-lt flex-1 ft-se-14 mg-rt-30">
					<div class="mg-bt-20 ft-se-16 ft-bd">
						{{$t('footer.call_tips')}}
					</div>
					<div class="clr-949">
						{{$t('footer.adress')}}
					</div>
					<div class="mg-tp-10 clr-949">
						{{$t('footer.postcode')}}
					</div>
					<div class="w-100 mg-tp-10 ft-se-14 clr-949">
						{{$t('footer.call')}}
					</div>

				</div>



				<div class="flex-1  tx-lt ">
					<div class="mg-bt-20 ft-se-16 ft-bd">
						{{$t('footer.ICP_tips')}}
					</div>
					<div class="flex-row ft-se-14 clr-949">
						<a href="https://beian.miit.gov.cn" class="flex-row ft-se-14 clr-949"><span
								class="mg-rt-15">{{$t('footer.ICP1')}}</span></a>
						<!-- <img src="@/assets/img/index/icp.png" alt="" srcset="" style="width: 16px; height: 18px;"/>		<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040102700068" class="flex-row ft-se-14 clr-949"> <span class="mg-lt-5">{{$t('footer.ICP2')}}</span> </a> -->
					</div>

				</div>
			</div>
		</footer>

		<!-- <el-dialog title="" :visible.sync="show" :before-close="handleClose" width="600px">
		 <login />
		</el-dialog> -->
	</div>
</template>

<script>
	// import login from '../login/index'
	import $ from 'jquery'
	import {
		getToken,
		setToken,
		removeToken
	} from '@/utils/auth'
	import {
		paramsSpliter
	} from '@/utils/urlParams'
	import {
		companyStatus
	} from '@/api/company'
	export default {
		components: {
			// login
		},
		data() {
			return {
				language: localStorage.getItem("lang") || "EN",
				navList: [],
				userList: [],
				show: false,
				isLogin: false,
				user: {},
			};
		},
		watch: {
			$route(to, from) {
				console.log('路由变化了')
				console.log('当前页面路由：' + to.path);
				let index = this.navList.findIndex(item => item.path === to.path)
				localStorage.setItem('currentIndex', index)
				console.log(index, '上一个路由：' + from);
				this.loadNav()
			},
		},
		computed: {
			key() {
				return this.$route.path + Math.random()
			}
		},
		created() {
			// 统一认证登录回调url里面会有code
			let params = paramsSpliter(window.location.href)
			this.isLogin = getToken() ? true : false
			if (!getToken()) {
				if (params.code) {
					const loading = this.$loading({
						lock: true,
						text: '登录中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.01)'
					});
					this.$store.dispatch("TyrzLogin", params).then(() => {
						loading.close();
						localStorage.removeItem('currentIndex')
						location.reload()

					}).catch(() => {
						loading.close();
					});
				}
			} else {
				this.$store.dispatch('GetInfo').then(() => {
					this.user = this.$store.state.user.userInfo
				}).catch(err => {})

			}


			// if(getToken()){
			// 	this.isLogin = true
			// }
			this.init()
		},
		mounted() {
			this.loadNav()
		},
		methods: {
			handleLogin() {
				// this.show = true
				this.$router.push({
					path: '/login'
				})
			},
			handleClose() {
				this.show = false
			},
			loadNav() {
				var $listsObj = $("#navs").children();
				var $activeObj = $("#active");
				var lefts = 0;
				var widths = 0;
				// 获取缓存中的路由索引
				let index = localStorage.getItem('currentIndex') ? localStorage.getItem('currentIndex') : 0
				// console.log('当前索引', localStorage.getItem('currentIndex'), index)
				// let index = currentIndex != -1 ? currentIndex : 0
				//获取第一个li标签的宽度
				widths = $listsObj.eq(index).innerWidth(); //innerWidth jQuery里获取包含内边距的宽度
				//设置红色移动元素的宽度
				$activeObj.width(widths + "px");
				//将第一个li的背景颜色设置为红色

				$listsObj.eq(index).css({
					"borderBottom": "#4baf4f 4px solid"
				});
				$listsObj.eq(index).children('a').css({
					"color": "#4baf4f"
				})
				$activeObj.css({
					"left": $listsObj.eq(index).position().left + "px"
				}); //可移动盒子距左边的距离等于当前li对象距父级盒子左边的距离
				// $listsObj.eq(0).css({"backgroundColor":"#4baf4f"});
				// $listsObj.eq(0).children('a').css({"color":"#fff"})
				// console.log($listsObj.eq(0).children('a').css({"color":"#fff"}),'1111')
				$listsObj.mouseover(function() {
					$activeObj.width($(this).innerWidth() + "px"); //鼠标移动到li标签上时将可移动的红色的盒子的宽度设置为当前li标签的宽度
					//position()方法是获取元素的设置了定位的父级元素的距左/距上的方法
					$activeObj.css({
						"left": $(this).position().left + "px"
					}); //可移动盒子距左边的距离等于当前li对象距父级盒子左边的距离
					// $(this).children('a').css({"color":"#fff"})
					// $(this).siblings().children('a').css({"color":"#555"})
				})
				//鼠标离开li标签的效果
				$listsObj.mouseout(function() {
					// console.log(lefts, '离开')
					$activeObj.width(widths); //鼠标离开li标签的时候可移动的盒子的宽度恢复到默认宽度
					// $activeObj.css({"left":lefts+"px"});//鼠标离开li标签的时候可移动的盒子距左边的距离恢复到默认距左边的距离
					$activeObj.css({
						"left": $listsObj.eq(index).position().left + "px"
					})
					// $(this).children('a').css({"color":"#555"})
				})
				//当点击li标签的时候改变可移动盒子的默认宽度和默认距左边的距离
				$listsObj.click(function() {
					$listsObj.css({
						"borderBottom": "#4baf4f 0px solid"
					}); //鼠标点击li标签的时候先将所有li标签的背景颜色去掉
					$(this).siblings().children('a').css({
						"color": "#555"
					})
					$(this).css({
						"borderBottom": "#4baf4f 4px solid"
					}); //将当前被点击的li标签的背景颜色设置为红色
					$(this).children('a').css({
						"color": "#4baf4f"
					})

					// $listsObj.css({"backgroundColor":""});//鼠标点击li标签的时候先将所有li标签的背景颜色去掉
					// $(this).siblings().children('a').css({"color":"#555"})
					// $(this).css({"background":"#4baf4f"});//将当前被点击的li标签的背景颜色设置为红色
					// $(this).children('a').css({"color":"#fff"})
					//改变可移动盒子的默认宽度
					widths = $(this).innerWidth();
					//改变可移动盒子距左边的默认距离
					lefts = $(this).position().left;
					$activeObj.width(widths + "px");
					$activeObj.css({
						"left": lefts + "px"
					})
				})
			},
			init() {
				this.navList = this.$i18n.messages[this.$i18n.locale].nav.navList
				this.userList = this.$i18n.messages[this.$i18n.locale].nav.usernav
				console.log(this.navList, '===========');
			},
			changeLangEvent(local) {
				console.log(local, '8888888')
				console.log(this.$i18n);
				if (this.language == "EN") {
					localStorage.setItem("locale", "zh");
					this.$i18n.locale = localStorage.getItem("locale");
					// this.$message({
					// 	message: "切换为中文！",
					// 	type: "success"
					// });
					localStorage.setItem("lang", "ZH");
					this.language = "ZH";
					location.reload(); //重新加载
				} else if (this.language == "ZH") {
					localStorage.setItem("locale", "en");
					this.$i18n.locale = localStorage.getItem("locale");
					// this.$message({
					// 	message: "Switch to English!",
					// 	type: "success"
					// });
					localStorage.setItem("lang", "EN");
					this.language = "EN";
					location.reload();
				}
			},
			handleRegister() {
				this.$router.push({
					path: '/register'
				})
			},
			handlePath(item) {
				console.log(item, 'ppp')
				if (item.id == 2) {
					this.$router.push({
						path: item.path
					})
				} else if (item.id == 1) {
					companyStatus().then(res => {
						console.log(res, 888)
						if (res.data.status == '1') {
							this.$confirm('企业认证中', '提示', {
								confirmButtonText: '确	认',
								cancelButtonText: '取 消',
								type: 'warning'
							}).then(() => {

							}).catch(() => {});
						} else if (res.data.status == '0') {
							this.$confirm('企业已认证', '提示', {
								confirmButtonText: '确	认',
								cancelButtonText: '取 消',
								type: 'warning'
							}).then(() => {

							}).catch(() => {});
						} else {
							this.$router.push({
								path: item.path
							})
						}
					})
				} else {
					this.$confirm('确定退出登录吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$store.dispatch('LogOut').then(() => {
							this.$router.push({
								path: '/login'
							})
						})
					}).catch(() => {});
				}
			},
			handleToPath(item) {
				console.log(item.path.includes('/portal'), 999)
				if (item.path.includes('/portal') || item.path.includes('/feedback')) {
					if (!getToken()) {
						this.$confirm('您目前未登录有色行业EPD平台，请登录后再进行操作？', '登录提示', {
							confirmButtonText: '登 录',
							cancelButtonText: '取 消',
							type: 'warning'
						}).then(() => {
							this.$store.dispatch('LogOut').then(() => {
								this.$router.push('/login')
							})
						}).catch(() => {});

						return
					} else {
						this.$router.push(item.path)
					}
				} else {
					this.$router.push(item.path)
				}

			}
		}
	}
</script>

<style scoped lang="scss">
	@import url('../../assets/css/nav.css');

	// @import url('../../assets/css/style.blue.css');
	// @import url('../../assets/css/style.pink.css');
	.w-1250 {
		width: 1250px;
	}

	.nav-holder {
		display: flex;
		justify-content: center;
		height: 70px;
		// position: absolute;
		// width: 100%;
		box-sizing: border-box;
		border-bottom: 0.01rem solid hsla(0, 0%, 93.3%, 0);
		z-index: 10;
		background: #fff;
		box-shadow: 0 2px 8px -2px rgba(0, 0, 0, .05);
	}

	.dropdown:hover .dropdown-menu {
		display: block;
	}

	.dropdown-menu {
		width: 200px;
		padding: 0 15px;
		position: absolute;
		left: 0;
		z-index: 12;
		top: 71px;
		box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
		display: none;
		background: #fff;
		box-sizing: border-box;
		border: 0.01rem solid hsla(0, 0%, 93.3%, 0);
		border-radius: 5px;
		// background: #fff;
		// box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.2);
		// transition: transform 1.1s, filter .5s;
		// cursor: pointer;
	}



	.dropdown-menu li {
		padding: 0;
		height: 50px;
		line-height: 50px;
		border-bottom: #e7e7e7 solid 1px;

	}

	.dropdown-menu li:last-child {
		border-bottom: #e7e7e7 solid 0px;
	}

	.dropdown-item {
		width: 100%;
		font-size: 16px;
		height: 100%;
		line-height: 50px;
		transition: transform 0.5s;
		cursor: pointer;

	}

	.dropdown-menu-u {
		width: 220px;
		padding: 0 15px;
		position: absolute;
		right: 0;
		z-index: 12;
		top: 69px;
		box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
		display: none;
		background: #fff;
		box-sizing: border-box;
		border: 0.01rem solid hsla(0, 0%, 93.3%, 0);
		border-radius: 5px;
		// background: #fff;
		// box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.2);
		// transition: transform 1.1s, filter .5s;
		// cursor: pointer;
	}

	.dropdown-menu-u li {
		padding: 0;
		height: 50px;
		// margin: 0 15px;
		// line-height: 50px;
		border-bottom: #e7e7e7 solid 1px;
	}

	.dropdown-menu-u li:last-child {
		border-bottom: #e7e7e7 solid 0px;
	}

	.user:hover .dropdown-menu-u {
		display: block;
	}

	.dropdown-item:hover {
		color: #4baf4f;
		// font-size: 18px;
		transform: scale(1.1);
		// background: #4baf4f;
	}

	.login {
		height: 40px;
		line-height: 40px;
		color: #fff;
		background: #4baf4f;
		padding: 0 20px;
		cursor: pointer;
	}

	.lang-item {
		color: #555;
		cursor: pointer;
	}

	.lang-item:hover {
		color: #4baf4f;
	}

	.langActive {
		color: #4baf4f;
	}

	.footer {
		width: 100%;
		// position: fixed;
		// bottom: 0;
		// left: 0;
		height: 200px;
		box-sizing: border-box;
		// border-top: 0.01rem solid hsla(0, 0%, 93.3%, 0);
		z-index: 10;
		background: #f6f7fb;
		// box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.2);
		// box-shadow: 0.125rem 0.125rem  0  rgba(0, 0, 0, 0.075);
	}

	.content {
		width: 100%;
		margin-top: 70px;
	}

	.app-main {
		// height: auto;
		padding-top: 72px;
	}
</style>